import { Directive, ElementRef, HostListener } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[appOpenDropdown]',
  standalone: false
})
export class OpenDropdownDirective {
  constructor(
    private readonly elemRef: ElementRef,
    private readonly router: Router
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
      // Remove the 'show-dropdown' class and add 'hide-dropdown' classes when the route changes
      const dropdownElement = this.elemRef.nativeElement.nextElementSibling;
      if (dropdownElement) {
        dropdownElement.classList.remove('show-dropdown');
        dropdownElement.classList.add('hide-dropdown');
      }
    });
  }

  @HostListener('document:click', ['$event', '$event.target'])
  onClick(event: Event, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }

    const clickedInside = this.elemRef.nativeElement.contains(targetElement);
    const dropdownElement = this.elemRef.nativeElement.nextElementSibling;

    if (clickedInside) {
      dropdownElement.classList.toggle('show-dropdown');
      dropdownElement.classList.remove('hide-dropdown');
    } else {
      dropdownElement.classList.remove('show-dropdown');
      dropdownElement.classList.add('hide-dropdown');
    }

    event.stopPropagation();
  }
}
